//TODO consider removing this component and just using Typography throughout site due to differing product price types
//e.g custom pricing
import classNames from "classnames"
import React from "react"

import Typography, { TypographySize } from "./Typography"

import { Color } from "constants/V2/color"

export type NumberDisplayAdornmentPosition = "right" | "left"

export type NumberDisplayValueProps = {
  superscriptText?: string
  sideScriptText?: string
  subscriptText?: string
  value?: string | number
  adornmentText: string
}

type NumberDisplayProps = {
  valueFontSize?: TypographySize
  type: "price" | "percentage"
  textColor: Color
  strikeSuperscriptText?: boolean
  size: "small" | "large"
  sideScriptTextColor?: Color
  strikeSideScriptText?: boolean
  enableThousandSeparator?: boolean
  adornmentTextPosition: NumberDisplayAdornmentPosition
  headingBodyText?: string
  alignment?: "center" | "left"
} & NumberDisplayValueProps

const NumberDisplay = ({
  valueFontSize,
  value,
  textColor,
  superscriptText,
  strikeSuperscriptText,
  subscriptText,
  size,
  type,
  adornmentTextPosition,
  adornmentText,
  enableThousandSeparator,
  sideScriptText,
  sideScriptTextColor,
  strikeSideScriptText,
  alignment = "left",
}: NumberDisplayProps) => {
  const isAdornmentTextRight =
    type === "percentage" || adornmentTextPosition === "right"

  return (
    <div>
      {superscriptText && (
        <div className="flex gap-4">
          <Typography
            weight="medium"
            size="body-md"
            font="grotesk"
            color={textColor}
            text={superscriptText?.split(" ")[0]}
            leadingNone
          />
          <Typography
            weight="medium"
            size="body-md"
            font="grotesk"
            color={textColor}
            text={superscriptText?.split(" ").slice(1).join(" ")}
            leadingNone
            className={classNames({
              "line-through": strikeSuperscriptText,
            })}
          />
        </div>
      )}

      <div className="flex items-end gap-4">
        <div
          className={classNames("flex", {
            "flex-row-reverse justify-end": isAdornmentTextRight,
            "mx-auto": alignment === "center",
          })}
        >
          {/* The isNan check is a patch */}
          {value !== undefined &&
            (typeof value === "number" || !isNaN(Number(value))) &&
            value !== 0 && (
              <Typography
                font="grotesk"
                weight="medium"
                color={textColor}
                text={type === "price" ? adornmentText : "%"}
                size={
                  isAdornmentTextRight
                    ? size === "large"
                      ? "h2"
                      : "h5"
                    : size === "large"
                      ? "lead-lg"
                      : "lead-md"
                }
                className={classNames({
                  "pr-[2px] pt-4": !isAdornmentTextRight && size === "large",
                  "pr-[2px] pt-[2px]":
                    !isAdornmentTextRight && size === "small",
                  "!text-h5": isAdornmentTextRight && size === "small",
                })}
              />
            )}

          <Typography
            size={valueFontSize || (size === "large" ? "h2" : "h5")}
            font="grotesk"
            weight="medium"
            color={textColor}
            text={
              typeof value === "number"
                ? type === "price" && enableThousandSeparator
                  ? value.toLocaleString("en-US")
                  : value.toString()
                : typeof value === "string"
                  ? value
                  : "TBA"
            }
            className={classNames({
              "!text-h5": size === "small" && !valueFontSize,
            })}
          />
        </div>

        {sideScriptText && (
          <Typography
            font="grotesk"
            size="body-sm"
            weight="medium"
            color={sideScriptTextColor || textColor}
            text={sideScriptText}
            className={classNames("pb-10", {
              "line-through": strikeSideScriptText,
            })}
          />
        )}
      </div>

      {subscriptText && (
        <Typography
          weight="book"
          font="grotesk"
          size="body-sm"
          color={textColor}
          text={subscriptText}
          className={classNames("-mt-8 lg:mt-0", {
            "text-center": alignment === "center",
            "opacity-50": size === "small",
          })}
        />
      )}
    </div>
  )
}

export default NumberDisplay
